import { TextBlock } from '@setplex/arcana'
import { useUnit } from 'effector-react'
import { useEffect, useRef } from 'react'
import { $toa, error } from '../model'
import { BodyTextBlock } from './BodyTextBlock'
import classes from './style.module.css'

Body.displayName = 'Body'
export function Body(): JSX.Element | null {
  const { toa, err } = useUnit({
    toa: $toa,
    err: error.$loading,
  })

  // animate expand height on content load
  const ref = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    if (ref && ref.current) {
      ref.current.style.maxHeight = `${ref.current.scrollHeight}px`
    }
  }, [ref, toa, err])

  return (
    <TextBlock>
      <div className={classes.height} ref={ref}>
        <BodyTextBlock />
      </div>
    </TextBlock>
  )
}
